// extracted by mini-css-extract-plugin
module.exports = {"container":"Client_container__2HJy8","all_tags_container":"Client_all_tags_container__29WY9"};